module.exports = __webpack_public_path__ + "static/media/image2.94238a10.png";